import { createSlice } from "@reduxjs/toolkit";

export interface OpportunityInfo {
  projectName: string;
  address: string;
  market: string;
  subMarket: string;
  projectType: string;
  constructionType: string;
  procurementType: string;
  sourcingDocument: string;
  developmentPartner: string;
  squareFeet: number;
  // budgetAcquisition: number;
  // budgetConstruction: number;
  // budgetSoft: number;
  // budgetFinance: number;
  // budgetDevelopment: number;
  // projectBudget: number;
  // debt: number;
  // equity: number;
  // other: number;
}

const initialState: OpportunityInfo = {
  projectName: "",
  address: "",
  market: "",
  subMarket: "",
  projectType: "",
  constructionType: "",
  procurementType: "",
  sourcingDocument: "",
  developmentPartner: "",
  squareFeet: 0,
  // budgetAcquisition: 0,
  // budgetConstruction: 0,
  // budgetSoft: 0,
  // budgetFinance: 0,
  // budgetDevelopment: 0,
  // projectBudget: 0,
  // debt: 0,
  // equity: 0,
  // other: 0,
};

export const OpportunitySlice = createSlice({
  name: "opportunityInfo",
  initialState,
  reducers: {
    set(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    // addBudget(state, { payload }) {
    //   return {
    //     ...state,
    //     projectBudget: state.projectBudget + payload,
    //   };
    // },
  },
});

export const { set } = OpportunitySlice.actions;

export default OpportunitySlice.reducer;
